module.exports = __webpack_public_path__ + "img/figure-5.58c6eb94.png";